import Dexie, { type Table } from 'dexie';
import type { Project, Column, Task, SyncQueueItem, FileCacheEntry } from '../types';

export interface OfflineProject extends Project { updatedAt?: string; }
export interface OfflineColumn extends Column { updatedAt?: string; }
export interface OfflineTask extends Task { updatedAt?: string; }

class OfflineDatabase extends Dexie {
  projects!: Table<OfflineProject, string>;
  columns!: Table<OfflineColumn, string>;
  tasks!: Table<OfflineTask, string>;
  syncQueue!: Table<SyncQueueItem, number>;
  fileCache!: Table<FileCacheEntry, string>;

  constructor() {
    super('kan-do-offline');
    this.version(1).stores({
      projects: 'id',
      columns: 'id, projectId',
      tasks: 'id, columnId',
      syncQueue: '++id, status, entityType, boardId, queuedAt',
      fileCache: 'fileUrl',
    });
  }
}

export const offlineDb = new OfflineDatabase();
